export const ACTION_COLUMN_WIDTH = 315
export const STATUS_COLUMN_WIDTH = 155
export const AMOUNT_COLUMN_WIDTH = 160
